export default __webpack_public_path__ + "static/media/match.a19a31b9.png";